import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { OfferItem as addAncilliariesOfferItem } from 'src/app/model/screen/add-ancilliaries-screen';
import { AddBaggageScreen, BaggageDropdownList } from 'src/app/model/screen/add-baggage-screen';
import { ConfirmBookingScreen } from 'src/app/model/screen/confirm-booking-screen';
import { OfferPriceScreen, SelectedBaggageDetail } from 'src/app/model/screen/offer-price-screen';
import { PassengerDetailScreen, PassengerServiceDetails } from 'src/app/model/screen/passenger-detail-screen';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';

@Component({
  selector: 'app-add-baggage-screen',
  templateUrl: './add-baggage-screen.component.html',
  styleUrls: ['./add-baggage-screen.component.scss']
})
export class AddBaggageScreenComponent implements OnInit {
  MEAL_IMAGE_URL = 'https://images.ctfassets.net/nwnmkeyu03hy/3ZkddVwyqYltOZeb6HrE2J/5791912c6bbf60323a7b6ce298293521/meal.JPG';
  EXCESS_BAGGAGE_IMAGE_URL = 'https://images.ctfassets.net/nwnmkeyu03hy/3HlwzQ32vk2hFdpBpbZkDG/f94d0181656576d49ffff4100aece272/bag.JPG';
  DISABILITY_ASSISTANCE_IMAGE_URL = 'https://images.ctfassets.net/nwnmkeyu03hy/7cDuSOpG6XYpCBz8Ivu7O3/d3cda76ff87c6e402570ee53f076e17f/disability.JPG';
  LEAF_IMAGE_URL = 'https://images.ctfassets.net/nwnmkeyu03hy/pBKeJYEGJfuX0upFo45CK/e88824b03e71d65fba62b208a5b34d47/leaf.JPG';
  bagOfferID: any;
  selectedBoundIndex: any;
  selectedClimateDescription: any;
  newSelectedIndex: any[] = [];
  public flightListIds: any = [];

  public offerItemFlightRefs: any = [];
  public offerItem: any = [];
  public offerItemIds: any = [];
  offerItemIDforBag: any;
  public excessBagRefsIds: any = [];
  public excessBagList: any = [];

  public baggageForm: any = 1;

  public serviceType: any;

  public dropdownLabel: any = '';
  public dropdownImgSrc: any = '';
  public availableDescription: any[] = [];
  public selectedDescriptionDeatils: any;

  addBaggageScreen: AddBaggageScreen = {} as AddBaggageScreen;
  confirmBookingScreen: ConfirmBookingScreen = {} as ConfirmBookingScreen;
  passengerDetailScreen: PassengerDetailScreen = {} as PassengerDetailScreen;
  isClimateProduct: boolean = false;
  climateProductDetails: PassengerServiceDetails[] = [];
  bagName: any;
  selectedYearIndex: number = 0;
  selectedCityList: any[] = [];
  climateDescriptionMap = new Map();
  constructor(private formBuilder: FormBuilder, private sandboxPageStateService: SandboxPageStateService) {}

  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.addBaggageScreen = this.sandboxPageStateService.getAddBaggageScreenDetail();
    this.serviceType = this.addBaggageScreen.serviceType;
    this.confirmBookingScreen = this.sandboxPageStateService.getConfirmBookingScreenData();
    this.passengerDetailScreen = this.sandboxPageStateService.getPassengerScreenDetail();
    if (this.addBaggageScreen && typeof this.addBaggageScreen.climateProductDetails !== 'undefined') {
      this.climateProductDetails.push(...this.addBaggageScreen.climateProductDetails);
    }
    this.initBaggageScreenMapping();
    if (this.serviceType === 'MEAL') {
      this.dropdownLabel = 'Meal';
      this.dropdownImgSrc = this.MEAL_IMAGE_URL;
    } else if (this.serviceType === 'BAG') {
      this.dropdownLabel = 'Excess Baggage';
      this.dropdownImgSrc = this.EXCESS_BAGGAGE_IMAGE_URL;
    } else if (this.serviceType === 'DisabilityAssistance') {
      this.dropdownLabel = 'Disability Assistance';
      this.dropdownImgSrc = this.DISABILITY_ASSISTANCE_IMAGE_URL;
    } else if (this.serviceType === 'CARB') {
      this.isClimateProduct = true;
      this.dropdownLabel = 'Climate Product';
      this.dropdownImgSrc = this.LEAF_IMAGE_URL;
    }
  }

  servHide(type: any) {
    if (this.addBaggageScreen.bookingType === 'offer-price-screen-add-service') {
      let patchSandboxSourceData = { mainMenu: 'offer-price', hideSideMenu: 'Yes' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      if (type === '1') {
        let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      } else {
        let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }
    }
  }

  initBaggageScreenMapping() {
    if (this.addBaggageScreen.jsonData) {
      let addBaggageScreenJSONData = this.addBaggageScreen.jsonData;
      let seatEnvelope = addBaggageScreenJSONData['SOAP:ENVELOPE'];
      let seatBody = seatEnvelope['SOAP:BODY'][0];
      let searviceListReponse = seatBody.SERVICELISTRS[0];
      let dataList = searviceListReponse.DATALISTS[0];
      let addBaggageOfferDetails = searviceListReponse.ALACARTEOFFER[0];
      let addBaggageResponseId = searviceListReponse.SHOPPINGRESPONSEID[0].RESPONSEID[0];
      this.addBaggageScreen.offerId = addBaggageOfferDetails.$.OFFERID;
      this.addBaggageScreen.owner = addBaggageOfferDetails.$.OWNER;
      this.addBaggageScreen.responseID = addBaggageResponseId;
      this.excessBagList = dataList.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;

      this.initServiceForm(addBaggageOfferDetails.ALACARTEOFFERITEM);
      this.mapExcessBags(this.excessBagList);
      this.mapOfferItems(addBaggageOfferDetails.ALACARTEOFFERITEM);
    } else {
      // console.log('this.addBaggageScreen.jsonData is undefined');
    }
  }

  mapOfferItems(offerItem: any) {
    let offerItemLength = offerItem.length;
    if (offerItemLength > 0) {
      offerItem.forEach((offer: any) => {
        let offerItemId = offer.$.OFFERITEMID;
        let offerItemIdArray = offerItemId.split('-');
        let offerServiceType = offerItemIdArray[offerItemIdArray.length - 1];
        if (offerServiceType === this.serviceType || this.addBaggageScreen.bookingType === 'offer-price-screen-add-service') {
          let segmentRefs = offer.ELIGIBILITY[0].SEGMENTREFS[0];
          let passengerRefs = offer.ELIGIBILITY[0].PASSENGERREFS[0].split(' ');
          let isOfferAvailableForPassenger: any = passengerRefs.indexOf(this.addBaggageScreen.passengerId);
          if (isOfferAvailableForPassenger !== -1) {
            let priceDetails = offer.UNITPRICEDETAIL[0].TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0];
            let currency = priceDetails.$.CODE;
            let price = priceDetails._;
            let serviceRefsIds = offer.SERVICE[0].SERVICEDEFINITIONREF[0];
            let excessBaggageIndex: any = this.excessBagRefsIds.indexOf(serviceRefsIds);
            let baggageName = '';
            let description: any;
            if (excessBaggageIndex !== -1) {
              let selectedExcessBaggage = this.excessBagList[excessBaggageIndex];
              baggageName = selectedExcessBaggage.NAME[0];
              description = selectedExcessBaggage.DESCRIPTIONS[0].DESCRIPTION;
            }
            let flightListIndex: any = this.flightListIds.indexOf(segmentRefs);
            if (flightListIndex !== -1) {
              let flightNumber = this.flightListIds[flightListIndex];
              this.addBaggageScreen.boundBaggageList[flightListIndex].flightNumber = flightNumber;
              let dropDownDetails: BaggageDropdownList = {
                offerItemID: offerItemId,
                currency: currency,
                price: price,
                baggageName: baggageName,
                description: description,
                flightNumber: segmentRefs,
                selectedBaggage: false
              };

              if (this.climateProductDetails.length === 0) {
                this.updateDropdownDetails(dropDownDetails, flightListIndex, segmentRefs);
              } else {
                let matched = false;
                this.climateProductDetails.forEach((element) => {
                  if (dropDownDetails.flightNumber === element.flightSegmentNumber && serviceRefsIds.includes(element.baggageName)) {
                    matched = true;
                  }
                });
                if (!matched) {
                  this.updateDropdownDetails(dropDownDetails, flightListIndex, segmentRefs);
                }
              }
            }
          }
        }
      });
    }
  }

  private updateDropdownDetails(dropDownDetails: BaggageDropdownList, flightListIndex: any, segmentRefs: any) {
    this.availableDescription.push({ description: dropDownDetails.description, baggageName: dropDownDetails.baggageName, offerItemId: dropDownDetails.offerItemID });
    this.addBaggageScreen.boundBaggageList[flightListIndex].baggageDropdown.push(dropDownDetails);
    this.addBaggageScreen.boundBaggageList[flightListIndex].baggageDropdown.filter((offerItemId: any) => {
      this.offerItemIDforBag = offerItemId.offerItemID;
    });
    this.addBaggageScreen.boundBaggageList[flightListIndex].flightNumber = segmentRefs;
  }

  initServiceForm(offerItemList: any) {
    let noServiceName: any = '';
    if (this.serviceType === 'BAG') {
      noServiceName = 'No Excess Baggage';
    } else if (this.serviceType === 'MEAL') {
      noServiceName = 'No Meal';
    } else if (this.serviceType === 'DisabilityAssistance') {
      noServiceName = 'No Disability Assistance';
    } else if (this.serviceType === 'CARB') {
      noServiceName = 'No SAF';
    }
    let baggageFormDetail = this.formBuilder.array([]);
    this.flightListIds = [];
    let description: any;
    let offerItemListLength = offerItemList.length;
    let dropDownDetails: BaggageDropdownList = {
      offerItemID: '0',
      currency: '',
      price: '0',
      baggageName: noServiceName,
      description: description,
      flightNumber: '',
      selectedBaggage: false
    };
    if (offerItemListLength > 0) {
      let boundOfferIndex: any = 0;
      offerItemList.forEach((offerItem: any) => {
        let offerItemId = offerItem.$.OFFERITEMID;
        let offerItemIdArray = offerItemId.split('-');
        let offerServiceType = offerItemIdArray[offerItemIdArray.length - 1];
        if (offerServiceType === this.serviceType || this.addBaggageScreen.bookingType === 'offer-price-screen-add-service') {
          let segmentRefs = offerItem.ELIGIBILITY[0].SEGMENTREFS[0];
          let isSegmentRefsPushed: any = this.offerItemFlightRefs.indexOf(segmentRefs);
          if (isSegmentRefsPushed === -1) {
            let fromGroup: any = this.formBuilder.group({
              flightNumber: [segmentRefs],
              boundOfferIndex: [boundOfferIndex],
              selectedBaggage: ['0'],
              formIndex: ['0']
            });
            this.flightListIds.push(segmentRefs);
            this.addBaggageScreen.boundBaggageList.push({ flightNumber: segmentRefs, baggageDropdown: [dropDownDetails], boundOfferIndex: boundOfferIndex });
            baggageFormDetail.push(fromGroup);
            boundOfferIndex++;
          }
        }
      });
    }
    this.baggageForm = this.formBuilder.group({
      boundBaggageList: baggageFormDetail
    });
  }
  inp_group(controlName: any) {
    return this.baggageForm.controls[controlName];
  }
  inp_arr(controlName: any) {
    return this.inp_group(controlName) as FormArray;
  }

  inp_arr_group(controlName: any, i: any) {
    return this.inp_arr(controlName).at(i) as FormGroup;
  }

  inp_arr_group_control(controlName: any, i: any, key: any) {
    return this.inp_arr_group(controlName, i).controls[key];
  }

  mapExcessBags(serviceDefinationList: any) {
    this.excessBagRefsIds = [];
    let len = serviceDefinationList.length;
    if (len > 0) {
      serviceDefinationList.forEach((serviceList: any) => {
        this.excessBagRefsIds.push(serviceList.$.SERVICEDEFINITIONID);
      });
    }
  }

  saveBaggageDetails() {
    if (this.addBaggageScreen.bookingType === 'offer-price-screen-add-service') {
      this.saveOfferPriceBaggageDetail();
    } else if (this.addBaggageScreen.bookingType === 'your-booking-screen-add-ancilliaries') {
      this.saveYourBookingAddAncilliariesDetails();
    }
  }

  saveYourBookingAddAncilliariesDetails() {
    let baggageFormValue = this.baggageForm.value;
    let formBoundBaggageList = baggageFormValue.boundBaggageList;
    // this.sandboxPageStateService.updatePassengerDetailScreenData(passengerDetailScreenData);
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    addAncilliariesScreenData.selectedOfferId = this.addBaggageScreen.offerId;
    addAncilliariesScreenData.selectedOwner = this.addBaggageScreen.owner;
    addAncilliariesScreenData.selectedResponseId = this.addBaggageScreen.responseID;

    let totSelectedOffer = addAncilliariesScreenData.selectedOfferItem.length;
    let currency = '';
    let pushOffer: boolean = true;
    let isServiceChoose: boolean = false;
    formBoundBaggageList.forEach((formBaggageDetail: any) => {
      if (formBaggageDetail.selectedBaggage !== '0') {
        isServiceChoose = true;
        let boundServiceDetail = this.addBaggageScreen.boundBaggageList[formBaggageDetail.boundOfferIndex].baggageDropdown[formBaggageDetail.selectedBaggage];
        if (totSelectedOffer > 0) {
          addAncilliariesScreenData.selectedOfferItem.forEach((offerItem: addAncilliariesOfferItem) => {
            if (this.addBaggageScreen.passengerId === offerItem.passengerId && offerItem.offerItemID === boundServiceDetail.offerItemID) {
              pushOffer = false;
            }
          });
        }
        currency = boundServiceDetail.currency;
        if (pushOffer) {
          //store in add ancilliaries screen
          addAncilliariesScreenData.selectedOfferItem.push({
            offerItemID: boundServiceDetail.offerItemID,
            passengerId: this.addBaggageScreen.passengerId,
            price: boundServiceDetail.price,
            type: this.serviceType
          });
          //store in passenger screen
          let passengerBaggageDetails: PassengerServiceDetails = {
            baggageName: boundServiceDetail.offerItemID,
            flightSegmentNumber: boundServiceDetail.flightNumber,
            offerItemId: '',
            price: '',
            tax: '',
            currency: '',
            total: ''
          };
          if (this.serviceType === 'BAG') {
            this.passengerDetailScreen.passengerDetail[this.addBaggageScreen.passengerIndex].passengerOtherDetails.passengerSelectedBaggageDetail.push(passengerBaggageDetails);
          } else if (this.serviceType === 'MEAL') {
            this.passengerDetailScreen.passengerDetail[this.addBaggageScreen.passengerIndex].passengerOtherDetails.passengerSelectedMealDetails.push(passengerBaggageDetails);
          } else if (this.serviceType === 'DisabilityAssistance') {
            this.passengerDetailScreen.passengerDetail[this.addBaggageScreen.passengerIndex].passengerOtherDetails.passengerSelectedDisablityServiceDetail.push(passengerBaggageDetails);
          } else if (this.serviceType === 'CARB') {
            this.passengerDetailScreen.passengerDetail[this.addBaggageScreen.passengerIndex].passengerOtherDetails.passengerSelectedProductClimateServiceDetail.push(passengerBaggageDetails);
          }
        }
      }
    });
    if (isServiceChoose) {
      addAncilliariesScreenData.displayService = this.serviceType;
    }
    addAncilliariesScreenData.currency = currency;
    this.sandboxPageStateService.updateAddAncilliariesScreenData(addAncilliariesScreenData);
    let patchSandboxSourceData = { mainMenu: 'add-ancilliaries-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  saveOfferPriceBaggageDetail() {
    let totalBagAmount: any = 0;
    let passengerBaggageDetails: PassengerServiceDetails[] = [];
    let offerPriceScreenDetail: OfferPriceScreen = this.sandboxPageStateService.getOfferPriceScreenData();
    let offerPriceScreenPassengerBaggageDetail = offerPriceScreenDetail.selectedBagOfferItem;
    let selectedBaggaeDetail: SelectedBaggageDetail[] = [];
    offerPriceScreenDetail.selectedBagOfferItem.offerId = this.addBaggageScreen.offerId;
    offerPriceScreenDetail.selectedBagOfferItem.owner = this.addBaggageScreen.owner;
    offerPriceScreenDetail.selectedBagOfferItem.responseId = this.addBaggageScreen.responseID;
    if (typeof offerPriceScreenPassengerBaggageDetail?.offerDetail !== 'undefined') {
      let selectedOfferLength = offerPriceScreenPassengerBaggageDetail.offerDetail.length;
      if (selectedOfferLength > 0) {
        offerPriceScreenPassengerBaggageDetail.offerDetail.forEach((baggageDetail: SelectedBaggageDetail) => {
          if (baggageDetail.passengerId !== this.addBaggageScreen.passengerId) {
            selectedBaggaeDetail.push({
              OfferItemID: baggageDetail.OfferItemID,
              passengerId: baggageDetail.passengerId,
              price: baggageDetail.price,
              currency: baggageDetail.currency,
              flightSegmentNumber: baggageDetail.flightSegmentNumber
            });
            totalBagAmount += +baggageDetail.price;
          }
        });
      }
    }

    let baggageFormValue = this.baggageForm.value;
    let formBoundBaggageList = baggageFormValue.boundBaggageList;
    formBoundBaggageList.forEach((formBaggageDetail: any) => {
      if (formBaggageDetail.selectedBaggage !== '0') {
        let boundBaggageDetail = this.addBaggageScreen.boundBaggageList[formBaggageDetail.boundOfferIndex].baggageDropdown[formBaggageDetail.selectedBaggage];
        selectedBaggaeDetail.push({
          OfferItemID: boundBaggageDetail.offerItemID,
          passengerId: this.addBaggageScreen.passengerId,
          price: boundBaggageDetail.price,
          currency: boundBaggageDetail.currency,
          flightSegmentNumber: boundBaggageDetail.flightNumber
        });
        totalBagAmount += +boundBaggageDetail.price;
        passengerBaggageDetails.push({
          baggageName: boundBaggageDetail.offerItemID,
          flightSegmentNumber: boundBaggageDetail.flightNumber,
          offerItemId: '',
          price: '',
          tax: '',
          currency: '',
          total: ''
        });
      }
    });

    offerPriceScreenDetail.selectedBagOfferItem.offerDetail = selectedBaggaeDetail;

    let flightPrice: any = offerPriceScreenDetail.offerPrice.priceDetail.flightPrice;
    let seatPrice: any = offerPriceScreenDetail.offerPrice.priceDetail.seatPrice;
    let total: any = +parseFloat(totalBagAmount) + parseFloat(flightPrice) + parseFloat(seatPrice);
    offerPriceScreenDetail.offerPrice.priceDetail.bagPrice = totalBagAmount;
    offerPriceScreenDetail.offerPrice.priceDetail.price = total;

    this.confirmBookingScreen.primeBookingTicketDetail.priceDetails.bagPrice = totalBagAmount;
    this.confirmBookingScreen.primeBookingTicketDetail.priceDetails.totalCharge = total;

    this.passengerDetailScreen.passengerDetail[this.addBaggageScreen.passengerIndex].passengerOtherDetails.passengerBaggageDetails = passengerBaggageDetails;

    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreen);
    this.sandboxPageStateService.updateConfirmBookingScreenData(this.confirmBookingScreen);
    this.sandboxPageStateService.updateOfferPriceScreenData(offerPriceScreenDetail);

    if (passengerBaggageDetails.length > 0) {
      let availableOtherOffers: any[] = [];
      this.sandboxPageStateService.updateUpsellOffersData(availableOtherOffers);
    }
    let patchSandboxSourceData: any = { mainMenu: 'offer-price', sandboxScreen: 'prime-sale-save-add-baggage' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  selectChangeHandler(event: any, addBaggageDetail: any, i: any) {
    this.selectedBoundIndex = i;
    let selectedValue = event.target.value;
    this.selectedClimateDescription = addBaggageDetail[selectedValue];
    let description = '';
    if (this.selectedClimateDescription.description === undefined) {
      this.climateDescriptionMap.set(i, '');
    } else {
      description = this.selectedClimateDescription.description;
      this.climateDescriptionMap.set(i, description);
    }
  }
}
